import { EventTypes } from 'redux-segment';
import ApiService from '../../util/api';
import { CREATE_INVITATION_ACCOUNT, RECEIVE_INVITATION_ACCOUNT, REQUEST_INVITATION_ACCOUNT } from './constants';

export function invitationAccountCreated() {
  const analytics = [
    {
      eventType: EventTypes.track,
      eventPayload: {
        event: 'Invitation Account Created'
      }
    }
  ];

  return {
    type: CREATE_INVITATION_ACCOUNT,
    meta: { analytics }
  };
}

function requestInvitationAccount() {
  return {
    type: REQUEST_INVITATION_ACCOUNT,
  };
}

function receiveInvitationAccount(json) {
  return {
    type: RECEIVE_INVITATION_ACCOUNT,
    payload: {
      account: json
    }
  };
}

export function fetchInvitationAccount() {
  return (dispatch) => {
    dispatch(requestInvitationAccount());
    return ApiService.get('/web-api/v1/invitation_account')
      .then(json => dispatch(receiveInvitationAccount(json)))
      .then(() => dispatch(invitationAccountCreated()));
  };
}

export function createInvitationAccount() {
  return dispatch => (
    ApiService.post('/web-api/v1/invitation_account')
      .then(json => dispatch(receiveInvitationAccount(json)))
      .then(() => dispatch(invitationAccountCreated(true)))
  );
}



/** WEBPACK FOOTER **
 ** ./src/cards/actions/invitationAccountActions.js
 **/